/* Const,Let & Var will be here */
export const TAB_SELECTION = 'TAB_SELECTION';

/* Const,Let & Var will be here */

export function onTabSelect(tabName) {
    return {
        type: TAB_SELECTION,
        selectedTabName: tabName
    };
}